import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-brand-navy text-white pt-20 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-16 mb-16">
          <div className="col-span-1 md:col-span-2">
            <Link to="/" className="inline-block mb-8 bg-white p-5 rounded-2xl shadow-lg transition-transform hover:scale-105">
              <img 
                src="https://media-manager-c.questera.ai/greta-media/7c98abf852f963e06195176deed57bb9c81b4f53d205af5ca5b2f9af1b9cfaa840d35f6737e086b8644a3796bedcf0cc/images/aW1hZ2UvcG5n/51bb34f9956cf11fb97ebb2a9db89eac.png" 
                alt="AI CoLab Studio" 
                className="h-20 md:h-24 w-auto object-contain"
              />
            </Link>
            <p className="text-gray-300 max-w-md mb-8 text-lg leading-relaxed">
              Helping social impact organisations lead AI with confidence without losing what makes them human.
            </p>
            <div className="flex items-center gap-2 text-gray-400 font-medium">
              <span className="w-8 h-px bg-brand-gold/50"></span>
              <p>Founded by Tomar Beh</p>
            </div>
          </div>

          <div>
            <h3 className="font-bold text-brand-gold mb-6 uppercase tracking-widest text-sm">Navigation</h3>
            <ul className="space-y-4">
              <li><Link to="/" className="text-gray-300 hover:text-brand-teal transition-colors text-base">Home</Link></li>
              <li><Link to="/start-here" className="text-gray-300 hover:text-brand-teal transition-colors text-base">Start Here</Link></li>
              <li><Link to="/safe-ai-framework" className="text-gray-300 hover:text-brand-teal transition-colors text-base">SAFE AI Framework</Link></li>
              <li><Link to="/work-with-us" className="text-gray-300 hover:text-brand-teal transition-colors text-base">Work With Us</Link></li>
              <li><Link to="/resources" className="text-gray-300 hover:text-brand-teal transition-colors text-base">Resources & Shop</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="font-bold text-brand-gold mb-6 uppercase tracking-widest text-sm">Connect</h3>
            <ul className="space-y-4">
              <li><Link to="/about" className="text-gray-300 hover:text-brand-teal transition-colors text-base">About Tomar</Link></li>
              <li><Link to="/contact" className="text-gray-300 hover:text-brand-teal transition-colors text-base">Contact</Link></li>
              <li><Link to="/newsletter" className="text-gray-300 hover:text-brand-teal transition-colors text-base">Newsletter</Link></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-10 flex flex-col md:flex-row justify-between items-center text-sm text-gray-400">
          <div className="text-center md:text-left mb-4 md:mb-0">
            <p className="mb-1">&copy; {new Date().getFullYear()} AI CoLab Studio. All rights reserved.</p>
            <p className="text-xs opacity-60">AI Colab Studio is a Trading Name of AY Productions LTD Company number 15001150</p>
          </div>
          <div className="flex gap-8">
            <Link to="/privacy" className="hover:text-white transition-colors">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-white transition-colors">Terms & Conditions</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;